/* These values map to event.key **/
export const KEY_VALUES = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  END: 'End',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  HOME: 'Home',
  SPACE: ' ',
  SUBTRACT: '-',
  TAB: 'Tab',
};

/* These values map to event.code **/
export const CODE_VALUES = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  END: 'End',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  HOME: 'Home',
  SPACE: 'Space',
  SUBTRACT: 'Minus',
  TAB: 'Tab',
  NUMPAD_ENTER: 'NumpadEnter', // Only works with event.code.
};
